import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const RM_ASSOCIATION_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('RM_ASSOCIATION');
export const RM_ASSOCIATION_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	RM_ASSOCIATION_CRUD_ACTION_CONSTANTS
);
